import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "marketing-sms-image-preview" */'./MarketingSMSImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('marketing-sms-image-preview')),
  LoadingComponent: () => null
});